// extracted by css-extract-rspack-plugin
export default {"root":"PCvS3RRv67clonL9","excerpt":"CYqB9aOc7owns3LW"};